var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.customClass,attrs:{"color":_vm.color,"dense":"","depressed":"","loading":_vm.$store.state.loading,"text":_vm.text,"disabled":_vm.disabled},on:{"click":_vm.submit}},[_vm._v(" "+_vm._s(_vm.txt)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }